// Точка входа клиента: собирает store с браузерными портами (fetch, XHR, хранилища, живой канал), оболочку окон и роутер,
// сбрасывает отложенную запись реестра при уходе со страницы и монтирует <App>.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter } from 'react-router-dom'

// Шрифты — свои файлы, без CDN: Inter для текста, JetBrains Mono для чисел и кодов (как в старом клиенте).
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import '@krp/ui-kit/tokens.css'
import { browserStorages, liveUrl } from '@krp/client-runtime'

import { App } from './app/App'
import { appRoutes } from './app/routes'
import { createAppStore } from './app/store'
import { reportServerBuild } from './update/serverBuild'
import { browserSessionChannel } from './composition/sessionChannel'
import { createAppWindowShell } from './composition/windows'
import './app/shell.css'

const { store, persistence } = createAppStore({
  fetch: (input, init) => globalThis.fetch(input, init),
  xhr: () => new XMLHttpRequest(),
  onServerBuild: reportServerBuild,
  storages: browserStorages(),
  namespace: `krp:${import.meta.env.MODE}`,
  leaveTo: (url) => window.location.assign(url),
  channel: browserSessionChannel(),
  devTools: import.meta.env.DEV,
  // Живой канал (LIVE): тот же origin, cookie-сессия шлюза; токенов в браузере нет.
  live: { url: () => liveUrl(window.location), connect: (url) => new WebSocket(url) },
})
// Уход со страницы (F5, закрытие): отложенная запись реестра не теряется.
window.addEventListener('pagehide', () => persistence.flush(store.getState()))
const shell = createAppWindowShell()
const browserFetch: typeof fetch = (input, init) => globalThis.fetch(input, init)
const router = createBrowserRouter(appRoutes(shell, browserFetch))

const root = document.getElementById('root')
if (root === null) throw new Error('Нет #root в index.html')

createRoot(root).render(
  <StrictMode>
    <App store={store} shell={shell} router={router} browserFetch={browserFetch} />
  </StrictMode>,
)
